import { render, staticRenderFns } from "./pickcar.vue?vue&type=template&id=c906d0f6&scoped=true"
import script from "./pickcar.vue?vue&type=script&lang=js"
export * from "./pickcar.vue?vue&type=script&lang=js"
import style0 from "./pickcar.vue?vue&type=style&index=0&id=c906d0f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c906d0f6",
  null
  
)

export default component.exports